import {useState} from 'react';

export function useSelectAnnotationBox({pageRefs, scale, annotations, onSelect}) {
    const [selecting, setSelecting] = useState(false);
    const [startPoint, setStartPoint] = useState(null);
    const [currentRect, setCurrentRect] = useState(null);
    const [currentPage, setCurrentPage] = useState(null);

    const handleMouseDown = (e) => {
        const page = pageRefs.current.find((el) => {
            const rect = el.getBoundingClientRect();
            return e.clientX >= rect.left && e.clientX <= rect.right &&
                e.clientY >= rect.top && e.clientY <= rect.bottom;
        });
        if (!page) return;

        const rect = page.getBoundingClientRect();
        const pageIndex = parseInt(page.dataset.index, 10);

        setCurrentPage(pageIndex);
        setStartPoint({x: e.clientX - rect.left, y: e.clientY - rect.top});
        setCurrentRect(null);
        setSelecting(true);
    };

    const handleMouseMove = (e) => {
        if (!selecting || startPoint == null || currentPage == null) return;

        const page = pageRefs.current[currentPage];
        const rect = page.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;

        setCurrentRect({
            x: Math.min(startPoint.x, x),
            y: Math.min(startPoint.y, y),
            width: Math.abs(startPoint.x - x),
            height: Math.abs(startPoint.y - y)
        });
    };

    const handleMouseUp = () => {
        if (selecting && currentRect && currentPage != null) {
            const pageNum = currentPage + 1;
            const [x0, y0, x1, y1] = [
                currentRect.x / scale,
                currentRect.y / scale,
                (currentRect.x + currentRect.width) / scale,
                (currentRect.y + currentRect.height) / scale
            ];

            const inBox = (bbox) => {
                if (!Array.isArray(bbox) || bbox.length < 4) return false;
                const [bx0, by0, bx1, by1] = bbox;
                return !(bx1 < x0 || bx0 > x1 || by1 < y0 || by0 > y1);
            };

            const matched = annotations.filter((a) => {
                if (a.page !== pageNum) return false;

                if (a.type === 'key_value') {
                    return inBox(a.field?.bbox) || inBox(a.value?.bbox);
                }
                if (inBox(a.bbox)) return true;
                if (Array.isArray(a.columns)) {
                    return a.columns.some(col => inBox(col.bbox));
                }
                return false;
            });

            if (onSelect) onSelect(matched);
        }

        setSelecting(false);
        setStartPoint(null);
        setCurrentRect(null);
        setCurrentPage(null);
    };

    return {
        currentRect,
        currentPage,
        handleMouseDown,
        handleMouseMove,
        handleMouseUp
    };
}
